<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <LeituraRegulamento />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import LeituraRegulamento from "../Components/Leituras/LeituraRegulamento.vue";
export default {
  name: "ReadORule",
  components: {
    LeituraRegulamento,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
